export default __webpack_public_path__ + "static/media/eye.17acd59c.svg";